import styled from "styled-components";

export const BottomText = styled.div`
  margin-right: 12px;
  font-size: 16px;
  font-weight: 400;
  color: #342309;
  text-align: right;
  margin-top: 8px;

  span {
    cursor: pointer;
  }
`;

export const GoogleLoginButton = styled.div`
margin-top: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 16px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;

export const TelegramLoginButton = styled.div`
margin-bottom: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background: linear-gradient(0deg, rgb(52, 46, 33), rgb(0, 0, 0));
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;
color: #fff;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;

export const SocialLoginWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;